import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';

import { getDayPeriod, getResponsiveImages } from '../components/business/app/landing-page/sign-up-banner/time-based-images';

export function useDayPeriodResponsiveImage(options?: { date?: Date; refreshMinutes?: number }): string {
  const { date, refreshMinutes = 10 } = options || {};
  const theme = useTheme();

  const bpValues = { sm: theme?.breakpoints?.values.md || 768, lg: theme?.breakpoints?.values.xl || 1280 };

  function categoryFromWidth(): 'mobile' | 'tablet' | 'desktop' {
    if (typeof window === 'undefined') return 'mobile';
    const width = window.innerWidth;
    if (width >= bpValues.lg) return 'desktop';
    if (width >= bpValues.sm && width < bpValues.lg) return 'tablet';
    return 'mobile';
  }

  const [src, setSrc] = useState<string>(() => {
    const period = getDayPeriod(date);
    const responsive = getResponsiveImages(period);
    // On initial render, fall back to width-based category (safe for rotation)
    return responsive[categoryFromWidth()];
  });

  useEffect(() => {
    function update() {
      const period = getDayPeriod(date);
      const responsive = getResponsiveImages(period);
      setSrc(responsive[categoryFromWidth()]);
    }

    update();
    const interval = window.setInterval(update, refreshMinutes * 60 * 1000);
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    return () => {
      window.clearInterval(interval);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [date, refreshMinutes, bpValues.sm, bpValues.lg]);

  return src;
}
